import { useTriggerLoadWithInput } from "@redotech/react-util/load";
import { useEffect, useState } from "react";

export function useRetryOnResolve<T>(
  dependentPending: boolean,
  fn: (input?: T) => Promise<void>,
): [{ pending: boolean }, (input?: T) => void] {
  const [state, setState] = useState<{ attempting: boolean; input?: T }>({
    attempting: false,
  });

  const [{ pending }, handler] = useTriggerLoadWithInput(
    async (input: T | undefined) => {
      if (dependentPending) {
        setState({ attempting: true, input });
      } else {
        try {
          await fn(input);
        } finally {
          setState({ attempting: false });
        }
      }
    },
  );

  useEffect(() => {
    if (state.attempting && !dependentPending) {
      handler(state.input!);
    }
  }, [dependentPending, state.attempting, state.input, handler]);

  return [{ pending: pending || state.attempting }, handler];
}
